import { useState } from "react";
import { Modal } from "react-bootstrap";
import FnService from "../../services/FantacyService";

export function useTeamDetailsModal(matchId) {
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [teamDetails, setTeamDetails] = useState([]);
  const [loadingTeam, setLoadingTeam] = useState(false);
  const [teamTitle, setTeamTitle] = useState("");

  const openTeamModal = async (teamId, title) => {
    try {
      setTeamTitle(title);
      setLoadingTeam(true);
      setShowTeamModal(true);
      const res = await FnService.GetUserTeamDetailsService(teamId, matchId);
      const data = res.data;
      if (data?.Status && Array.isArray(data.Result)) {
        setTeamDetails(data.Result);
      } else {
        setTeamDetails([]);
      }
    } catch (err) {
      console.error("Team details API error:", err);
      setTeamDetails([]);
    } finally {
      setLoadingTeam(false);
    }
  };

  const closeTeamModal = () => {
    setShowTeamModal(false);
    setTeamDetails([]);
    setTeamTitle("");
  };

  return { showTeamModal, teamDetails, loadingTeam, teamTitle, openTeamModal, closeTeamModal };
}

export default function TeamDetailsModal({ show, onHide, title, loading, players }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="bg-dark text-white">   
        <Modal.Title>{title} - Players</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-white">
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-light" />
            <p className="mt-2">Loading team details...</p>
          </div>
        ) : !players.length ? (
          <p className="text-center text-white-50">No team details found.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm table-dark table-striped mb-0">
              <thead>
                <tr>
                  <th>Player</th>
                  <th>Type</th>
                  <th>Credit</th>
                  <th>Role</th>
                  <th>Points</th>
                </tr>
              </thead>
              <tbody>
                {players.map((player, idx) => (
                  <tr key={idx}>
                    <td>{player.PlayerName}</td>
                    <td>{player.role}</td>
                    <td>{player.Credit}</td>
                    <td>
                      {player.Role === "Captain" ? (
                        <span className="badge bg-warning text-dark">C</span>
                      ) : player.Role === "Vice-Captain" ? (
                        <span className="badge bg-info text-dark">VC</span>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td>{player.FinalPoints || player.BasePoints || "-"}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="fw-bold">
                  <td colSpan="4" className="text-end">Total Points</td>
                  <td>
                    {players.reduce((sum, p) => sum + (parseFloat(p.FinalPoints || p.BasePoints) || 0), 0)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
